module.exports = __webpack_public_path__ + "img/region-bretagne.289a2f95.png";